import React from "react"
import cx from 'classnames'
import styles from "./styles.module.scss"

interface Props {
	theme: string
}
const BlockContainer:React.FC<Props> = ({theme, children}) => {
	const themeStyle = theme === "secondary" ? styles.SecondaryTheme : styles.PrimaryTheme
	return (
		<div className={cx(styles.Block, themeStyle)}>
			<div className={cx(styles.InnerBlock)}>
					{children}
			</div>
		</div>
	)
}

export default BlockContainer